import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// Components
import ErrorHandler from '../../../_molecules/ErrorHandler';
import EventBadge from '@molecules/EventBadge';
import {
    BodyMedium,
    DivWithShadowMediumUp,
    H4,
    SectionWrapperInner,
    SectionWrapperOuter,
    LinkRedesignRouter,
} from '@styled';

// Helpers
import colors from '@general/colors';
import useDocumentTitle from '@hooks/useDocumentTitle';
import TrackPageView from '@tracking/TrackPageView';
import { mediaQueries } from '@general/breakpoints';

const CardContainerOuterStyled = styled(DivWithShadowMediumUp)`
    @media ${mediaQueries.md} {
        padding: 32px 32px 19px 32px;
    }
`;

export const LinkStyled = styled(Link)`
    color: ${colors.link} !important;
    cursor: pointer;
`;

const Column1Styled = styled.div`
    display: none;

    @media ${mediaQueries.md} {
        display: block;
        grid-column: span 3 / span 3;
    }
`;

const Column2Styled = styled.div`
    grid-column: span 6 / span 6;
`;

const Column3Styled = styled.div`
    display: none;

    @media ${mediaQueries.md} {
        display: block;
        grid-column: span 3 / span 3;
    }
`;

const EventBadgePreviewPage = () => {
    useDocumentTitle('Event Badge Preview');

    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <H4 className="mb-1.5rem">My Upcoming Events</H4>

                        <CardContainerOuterStyled>
                            <BodyMedium>
                                This is a preview of the information that will appear on your event badges. If this
                                information is incorrect, please{' '}
                                <LinkStyled to="/my-icsc/account/edit-profile">edit your profile</LinkStyled>.
                            </BodyMedium>

                            <div className="grid grid-cols-12 mt-2rem">
                                <Column1Styled />
                                <Column2Styled>
                                    <EventBadge />
                                </Column2Styled>
                                <Column3Styled />
                            </div>
                        </CardContainerOuterStyled>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default EventBadgePreviewPage;
